export const environment = {
    production: false,
    domain: 'amplifyqa.auth.us-east-1.amazoncognito.com',
    redirectSignIn: 'https://grabacionesgenesys-test.pichincha.com/',
    redirectSignOut:'https://grabacionesgenesys-test.pichincha.com/home',
    social_providers: '["AzureEntra"]',
    getQueue:'/api/getQueue',
    getUsers:'/api/getUsers',
    getCampaign:'/api/getCampaign',
    getContanctList:'/api/getList',
    downloadRecords:'/api/downloadRecords',
    downloadZip:'/api/downloadZip',
    client_id:'7eq8gfvk9ian7abarmpi7mj5jq',
    featureFlag: true,
    session_timeout: 5,
    maxOpus:150,
    maxMP3:10,
  };
